import React from "react";
import { Navigate } from "react-router-dom";

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");

  // const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  // & should be considered in redirect
  const regex = new RegExp("[?&]" + name + "(=([^#]*)|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default ({ component: C, props: cProps, ...rest }) => {
  const redirect = querystring("redirect");
  // 未ログインでredirect先が無いものは"/"にリダイレクトする
  const flag = rest.path === "/login" && !redirect ? false : true;
  return (!cProps.is_authenticated && flag) ||
    (cProps.is_authenticated && cProps.is_loggingOut) ? (
    <C {...cProps} />
  ) : (
    <Navigate to={redirect === "" || redirect === null ? "/" : redirect} />
  );
};
